import { Component, element as $ } from '@contorion/core';

const CLASS_HIDDEN: string = 'hidden';
const SELECTOR_SHOW_LINK: string = '.js-password-show';
const SELECTOR_HIDE_LINK: string = '.js-password-hide';
const SELECTOR_INPUT: string = 'input';
const TYPE_TEXT: string = 'text';
const TYPE_PASSWORD: string = 'password';

export class PasswordComponent extends Component {
    get showLink(): HTMLLinkElement {
        return <HTMLLinkElement> $(SELECTOR_SHOW_LINK, this.element);
    }

    get hideLink(): HTMLLinkElement {
        return <HTMLLinkElement> $(SELECTOR_HIDE_LINK, this.element);
    }

    get input(): HTMLInputElement {
        return <HTMLInputElement> $(SELECTOR_INPUT, this.element);
    }

    constructor(protected element: HTMLElement) {
        super(element);

        if (this.showLink && this.hideLink) {
            this.showLink.addEventListener('click', this.onShowLinkClick.bind(this));
            this.hideLink.addEventListener('click', this.onHideLinkClick.bind(this));
        }
    }

    protected show(): void {
        this.input.type = TYPE_TEXT;
        this.showLink.classList.add(CLASS_HIDDEN);
        this.hideLink.classList.remove(CLASS_HIDDEN);
        this.input.focus();
    }

    protected hide(): void {
        this.input.type = TYPE_PASSWORD;
        this.showLink.classList.remove(CLASS_HIDDEN);
        this.hideLink.classList.add(CLASS_HIDDEN);
        this.input.focus();
    }

    protected onShowLinkClick(e: Event): void {
        e.preventDefault();

        this.show();
    }

    protected onHideLinkClick(e: Event): void {
        e.preventDefault();

        this.hide();
    }
}
